@if (run(); as current) {
  <app-side-panel [wide]="true" heading="Berechnung vom {{ current.createdAt | date: 'dd.MM.yyyy, HH:mm' }}" [subtitle]="(current.total | number: '1.0-0' : 'de-DE') + ' Analysen'" (closed)="close()">
    <div panelTags class="mt-2 flex">
      <span class="inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-md px-2 font-mono text-2xs" [class]="status()!.classes"><span class="size-1.5 rounded-full bg-current" aria-hidden="true"></span>{{ status()!.label }}</span>
    </div>

    <section class="grid shrink-0 grid-cols-3 border-b border-border" aria-label="Einstellungen">
      @for (fact of facts(); track fact.key; let index = $index) {
        <div class="flex min-w-0 flex-col gap-0.5 px-5 py-3" [class.border-l]="index % 3 !== 0" [class.border-t]="index >= 3">
          <span class="ks-eyebrow">{{ fact.key }}</span>
          <span class="truncate text-dense" [title]="fact.value">{{ fact.value }}</span>
        </div>
      }
    </section>

    @if (current.status === 'failed' && current.errorMessage) {
      <div class="shrink-0 border-b border-border px-5 py-3"><app-inline-notice tone="error" [message]="current.errorMessage" /></div>
    }

    <section class="grid shrink-0 grid-cols-2 border-b border-border" aria-label="Ergebnis">
      <div class="flex min-w-0 flex-col gap-2 px-5 py-4">
        <span class="ks-eyebrow">Ergebnis</span>
        <div class="flex h-2 gap-0.5 overflow-hidden rounded-[2px] bg-muted" role="img" aria-label="Ergebnis der Berechnung">
          @for (row of outcome(); track row.label) {
            @if (row.count) { <span style="flex-basis: 0" [style.flex-grow]="row.count" [style.background-color]="row.color" [hlmTooltipTrigger]="row.label + ': ' + row.count"></span> }
          }
        </div>
        <div class="flex flex-col">
          @for (row of outcome(); track row.label) {
            <div class="grid h-7 grid-cols-[0.5rem_minmax(0,1fr)_auto] items-center gap-2 text-dense" [class.text-muted-foreground]="!row.count">
              <span class="size-2 rounded-full" [style.background-color]="row.color" aria-hidden="true"></span>
              <span class="truncate">{{ row.label }}</span>
              <span class="font-mono text-xs">{{ row.count | number: '1.0-0' : 'de-DE' }}</span>
            </div>
          }
        </div>
      </div>
      <div class="flex min-w-0 flex-col gap-2 border-l border-border px-5 py-4">
        <span class="ks-eyebrow">Wo sie jetzt stehen</span>
        <div class="flex flex-col">
          @for (row of stages(); track row.stage) {
            <button type="button" class="-mx-2 grid h-7 grid-cols-[minmax(0,6rem)_minmax(0,1fr)_auto] items-center gap-2 rounded-md px-2 text-left text-dense transition-colors hover:bg-muted" [hlmTooltipTrigger]="row.meta.tip" (click)="showStage(row.stage)">
              <span class="truncate">{{ row.meta.label }}</span>
              <span class="h-1.5 rounded-[2px]" [style.width.%]="row.share" [style.background-color]="row.meta.color" aria-hidden="true"></span>
              <span class="font-mono text-xs">{{ row.count | number: '1.0-0' : 'de-DE' }}</span>
            </button>
          } @empty {
            <p class="text-xs text-muted-foreground">{{ members() ? 'Die Analysen sind nicht mehr Teil der Kampagne.' : 'Wird geladen…' }}</p>
          }
        </div>
      </div>
    </section>

    <section class="flex min-w-0 flex-col gap-2 px-5 py-4" aria-label="Analysen dieser Berechnung">
      <span class="ks-eyebrow">Analysen</span>
      @if (error()) {
        <app-inline-notice tone="error" [message]="error()" />
      } @else {
        <app-data-table
          [data]="rows()"
          [columns]="columns()"
          [rowId]="getRowId"
          [isLoading]="!members()"
          [pageSize]="pageSize"
          [showAddButton]="false"
          [showLimitFilter]="false"
          searchPlaceholder="Adresse suchen"
          emptyStateTitle="Keine Analysen"
          emptyStateDescription="Diese Berechnung hat keine Analysen, die noch zur Kampagne gehören."
          (rowClick)="open($event)"
        />
      }
    </section>

    <div panelFooter class="flex shrink-0 flex-wrap items-center gap-2 border-t border-border px-5 py-3">
      <button hlmBtn type="button" variant="ghost" size="sm" (click)="showAll()">In der Analysen-Tabelle zeigen</button>
      <span class="flex-1"></span>
      @if (failed().length && store.canStart()) {
        <button hlmBtn type="button" variant="outline" size="sm" [disabled]="store.running()" (click)="retry()">{{ retryLabel() }}</button>
      }
      @if (toReview().length) {
        <button hlmBtn type="button" size="sm" (click)="review()">{{ reviewLabel() }}</button>
      }
    </div>
  </app-side-panel>
}

<ng-template #stageTpl let-item><app-stage-chip [stage]="item.stage" /></ng-template>
